import React, { useState } from "react";

import { MySpinner } from "components/MySpinner";
import { getStockByWarehouse } from "services/apiWarehouse";

import "./skladPopup.scss";
import { Cut } from "components/Cut";

export const SkladPopup = ({ children, row }) => {
  const [show, setShow] = useState(false);
  const [balance, setBalance] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAndSetStock = () => {
    setLoading(true);
    getStockByWarehouse({
      nomenclature: row.nomenclature?.id,
    })
      .then((res) => {
        setBalance(res || []);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  const popupHandler = () => {
    setShow(true);
    getAndSetStock();
  };

  const calcInStock = () => {
    return balance.reduce(
      (acc, val) => acc + parseInt(val.balance?.inStock),
      0
    );
  };

  const calcInReserve = () => {
    return balance.reduce(
      (acc, val) => acc + parseInt(val.balance?.inReserve),
      0
    );
  };

  return (
    <div
      onMouseEnter={popupHandler}
      onMouseLeave={() => setShow(false)}
      className="sklad-hover"
    >
      {show && (
        <div className="sklad-hover__popup">
          {loading && <MySpinner overlay />}

          {balance.length > 0 && (
            <table className="table">
              <tbody>
                <tr>
                  <td style={{ width: "30%" }}>Склад</td>
                  <td style={{ width: "10%" }}>Ост.</td>
                  <td style={{ width: "10%" }}>Рез.</td>
                  <td style={{ width: "50%" }}>Рез. инфо</td>
                </tr>
                {balance.map((val) => (
                  <tr key={val.warehouse?.id}>
                    <td>{val.warehouse?.name}</td>
                    <td>{val.balance?.inStock}</td>
                    <td>{val.balance?.inReserve}</td>
                    <td>{val.balance?.reserve.map(v =>
                      <div key={v.orderId}>
                        <Cut><a href={`/sales/orders/${v.orderId}`} target="_blank" rel="noreferrer">{v.customer} </a></Cut>
                      </div>
                    )}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td>Итого:</td>
                  <td>
                    <b>{calcInStock()}</b>
                  </td>
                  <td>
                    <b>{calcInReserve()}</b>
                  </td>
                  <td>

                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      )}
      {children}
    </div>
  );
};
